/**
 * The product mark: an envelope flap over a signature stroke, on an iris tile. This is the same
 * drawing as public/favicon.svg — change one and change the other — inlined here so the shell and
 * auth screens can size and align it like any other element.
 */
export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label="OnBrand Mail"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="logomark-tile" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#8461fb" />
          <stop offset="1" stopColor="#6742e0" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill="url(#logomark-tile)" />
      <path
        d="M8.5 10.5 16 17l7.5-6.5"
        fill="none"
        stroke="#fdfcf9"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 23c2-2.8 3.4 1.6 5.5-.8 1.8-2 2.6 1.4 4.6-.4 1.6-1.5 2.9.6 4.9-.6"
        fill="none"
        stroke="#fdfcf9"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
